export default '/build/9c6c3889.png'